export default "__VITE_ASSET__BzbiuIJ3__"